import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoApiPaths } from '../../Constant/ApiPaths/BasicInfoApiPaths';
import { BasicInfoHttpGetService } from '../../Services/BasicInfoHttpService';

export const getElhaghiyehMenuContents = createAsyncThunk('basicinfo/getElhaghiyehMenuContents', async () => {
  return await BasicInfoHttpGetService({
    url: `${BasicInfoApiPaths.MenuContent.GetElhaghiyehMenuContents}`,
  });
});
